const MONTHS_IN_YEAR = 12;
const planMonthlyDuration = {
  annual: 12,
  monthly: 1,
  quarterly: 3,
  '6Month': 6,
  '24Month': 24,
};

export const getDurationMonths = subscriptionDuration => {
  return planMonthlyDuration[subscriptionDuration];
};

export const getPlanPaymentFrequencyPerYear = subscriptionDuration => {
  const duration = getDurationMonths(subscriptionDuration);
  return MONTHS_IN_YEAR / duration;
};

const roundPrice = price => Math.round(price * 100) / 100;

export const getPricePerMonth = ({ price, subscriptionDuration }) => {
  const duration = getDurationMonths(subscriptionDuration);
  const monthlyPrice = price / duration;
  return roundPrice(monthlyPrice);
};

/**
 * Gets the price per month and converts it to 2 fixed places to keep it consistent for ui display
 * @param {Object} plan - subscription plan
 * @returns {string} string price per month fixed to 2 places
 */
 export const getPricePerMonthFixed = plan => plan && getPricePerMonth(plan).toFixed(2);

export const getPricePerYear = ({ price, subscriptionDuration }) => {
  const multplier = getPlanPaymentFrequencyPerYear(subscriptionDuration);
  return price * multplier;
};

export const getPricePercentDecrease = (originalPrice, newPrice) => {
  const percentChange = Math.round(((originalPrice - newPrice) / originalPrice) * 100);
  return `${percentChange}%`;
};

export const getPercentSavings = (comparisonOffer, discountedOffer) => {
  const pricePerMonthDiscountOffer = getPricePerMonth(discountedOffer);
  // could be monthly or bi-annual offer
  const pricePerMonthComparisonOffer = getPricePerMonth(comparisonOffer);
  return getPricePercentDecrease(pricePerMonthComparisonOffer, pricePerMonthDiscountOffer);
};

export const getDollarSavings = (comparisonOffer, discountedOffer) => {
  const difference = getPricePerYear(comparisonOffer) - getPricePerYear(discountedOffer);
  const planFrequency = getPlanPaymentFrequencyPerYear(discountedOffer.subscriptionDuration);

  return roundPrice(difference / planFrequency);
};

export const getOfferFreeMonths = (comparisonOffer, discountedOffer) => {
  const pricePerYearComparisonOffer = getPricePerYear(comparisonOffer);
  const pricePerYearDiscountedOffer = getPricePerYear(discountedOffer);

  const priceDifference = pricePerYearComparisonOffer - pricePerYearDiscountedOffer;
  const pricePerMonth = getPricePerMonth(comparisonOffer);

  // TBD but using Math.round is fine for now
  return Math.round(priceDifference / pricePerMonth);
};

const MONTHLY_DURATION = 'monthly';
const ANNUAL_DURATION = 'annual';

const isPlanDuration = duration => plan => !!plan && plan.subscriptionDuration === duration;
export const isMonthlyPlan = isPlanDuration(MONTHLY_DURATION);
export const isAnnualPlan = isPlanDuration(ANNUAL_DURATION);

/**
 * Find a plan by id in plans array
 * @param {array} plans - list of plans to search in
 * @param {string} planId - plan id to search for
 * @returns {object}
 */
export const findPlanById = (plans, planId) => plans.find(plan => plan.planId === planId);

/**
 * Determines whether plan has a MSRP price by comparing there original price is different from the actual price
 * @param {object} plan - the plan
 * @returns {true | false}
 */
export const hasMSRPPrice = (plan = {}) => plan.originalPrice && plan.originalPrice !== plan.price;

/**
 * Determines whether plan has minerva classes
 * Currently hacky way using the planDataKey to check if it contains the word minerva in it
 * but it should probably be stored on the plan in the database
 * TODO - ask Chris to create extra column to store this info
 * @param {object} plan - the plan
 * @returns {true | false}
 */
export const isMinervaPlan = (plan = {}) => plan.planDataKey.includes('minerva');

/**
 * Returns the plan with the lowest price regardless of duration.
 * @param {array} planOptions - plan options to check
 * @returns {object}
 */
 export const getLowestPricedPlan = planOptions =>
 [...planOptions].sort((a, b) => a.price - b.price)[0];

/**
* Returns the plan with the highest price regardless of duration.
* @param {array} planOptions - plan options to check
* @returns {object}
*/
export const getHighestPricedPlan = planOptions =>
 [...planOptions].sort((a, b) => b.price - a.price)[0];


// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/planUtils.js